import { render } from "./SidebarMenuItemBot3.vue?vue&type=template&id=f63a02ca&scoped=true"
import script from "./SidebarMenuItemBot3.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot3.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot3.vue?vue&type=style&index=0&id=f63a02ca&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63a02ca"]])

export default __exports__